<template>
    <v-container fluid justify-center>
        <div class="project-container">
            <div v-if="this.singleProject" class="project-detail">
                <div class="mx-auto project-title">
                    <p>{{ singleProject.title }}</p>
                </div>
                <div class="pb-2 mx-auto" width="100%">
                    <v-img :src="singleProject.picture"></v-img>
                </div>
                <div class="mx-auto project-desc">
                    <p>{{ singleProject.projectDesc }}</p>
                </div>
                <div class="py-2 project-links">
                    <v-btn
                        :href="`${singleProject.githubLink}`"
                        target="_blank"
                        elevation="0"
                        size="medium"
                    >
                        <p>GitHub Repository Link</p>
                    </v-btn>
                    <v-btn
                        :href="`${singleProject.liveLink}`"
                        target="_blank"
                        elevation="0"
                        size="medium"
                    >
                        <p>Live Website Link</p>
                    </v-btn>
                </div>
            </div>
        </div>
    </v-container>  
</template>
    
<script>
import axios from 'axios';
import store from '../store';
export default {
    metaInfo() {
        return {
            title: this.title,
        }
    },
    name: 'singleProject',  
    data: () => ({
        singleProject: [],
        hostName: {
            portfolioServer: process.env.VUE_APP_PORTFOLIO_SERVER
        }
    }),
    props: ['id'],
    methods: {
    },
    mounted: async function() {
        let $vm = this;
        let reqId = { _id: $vm.id }
        await axios.get(`${this.hostName.portfolioServer}/api/project`, { params: reqId })
            .then(response => {
                store.commit("updateSingleProject", response.data[0])
                $vm.singleProject = response.data[0]
            })
            .catch(function(error) {
                console.log(error)
        })
    }
}
</script>
    
<style lang="scss" scoped>

.project-container {
    .project-detail {
        margin-left: auto !important;
        margin-right: auto !important;

        .project-title p {
            font-family: Bebas Neue;
            color: var(--v-tropicalIndigo-base) !important;
            font-size: 82px;
            line-height: 0.95;
            margin: 0;
            margin-bottom: 35px;
        }

        .project-desc {
            padding-top: 20px;

            p {
                font-family: Arial;
                font-size: 19px;
            }
        }

        .project-links {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: auto !important;
            margin-right: auto !important;
            justify-content: center;
            margin-top: 22px;

            .v-btn {
                margin: 3px;
                background-color: var(--v-tropicalIndigo-base);

                p {
                    color: white;
                    font-size: 14px;
                    font-weight: 600;
                    font-family: Arial;
                    background-color: var(--v-tropicalIndigo-base);                
                }
            }

            @media (width > 1000px) {
                flex-direction: row;
            }
        }

        p {
            font-family: Bebas Neue;
            line-height: 115%;
            margin: 0;
            font-size: 22px;
        }
    }

    @media (width > 1000px) {
        margin: 4px 50px;
    }
}
</style>